import styled, { css } from "styled-components";
import type { TableTextTone } from "./TablePrimitives.types";

const truncateStyles = css<{ $truncate?: boolean; $maxWidth?: string }>`
  ${({ $truncate, $maxWidth }) =>
    $truncate &&
    css`
      display: inline-block;
      max-width: ${$maxWidth ? `min(${$maxWidth}, 100%)` : "100%"};
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      vertical-align: middle;
    `}
`;

export const TableTextSurface = styled.span<{
  $tone: TableTextTone;
  $weight: 400 | 500 | 600;
  $numeric: boolean;
  $truncate?: boolean;
  $maxWidth?: string;
}>`
  min-width: 0;
  color: ${({ $tone, theme }) => {
    if ($tone === "muted") return theme.colors.inkSoft;
    if ($tone === "brand") return theme.colors.brand;
    return theme.colors.ink;
  }};
  font-weight: ${({ $weight }) => $weight};
  font-variant-numeric: ${({ $numeric }) => ($numeric ? "tabular-nums" : "normal")};
  letter-spacing: ${({ $numeric }) => ($numeric ? "0.01em" : "normal")};
  ${truncateStyles}
`;

export const TableLinkSurface = styled.a<{ $truncate?: boolean; $maxWidth?: string }>`
  min-width: 0;
  color: ${({ theme }) => theme.colors.brand};
  text-decoration: none;
  font-weight: 400;
  ${truncateStyles}

  &:hover {
    text-decoration: underline;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.brand};
    outline-offset: 2px;
    border-radius: 2px;
  }
`;
